import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../Layouts/Loader/Loader";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import AccessTemplateEditor from "./AccessTemplateEditor";

const AccessTemplateViewer = ({ file }) => {
  const { orgId } = useParams();
  const [templateData, setTemplateData] = useState(null);
  const [allGroups, setAllGroups] = useState([]);
  const [allRoles, setAllRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchAccessTemplate = async () => {
    try {
      setIsLoading(true);

      const [templateRes, groupRes, rolesRes] = await Promise.all([
        axiosInstance.get(`/access-templates/${file.id}`),
        axiosInstance.get(`/user-service/groups/org/${orgId}`),
        axiosInstance.get(`/user-service/role/org/${orgId}`)
      ]);

      setTemplateData(templateRes.data);
      setAllGroups(groupRes.data);
      setAllRoles(rolesRes.data);
    } catch (err) {
      setError("Failed to load access template.");
      handleApiError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAccessTemplate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id]);

  if (isLoading) return <Loader />;
  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }
  if (!templateData) return null;

  return (
    <AccessTemplateEditor
      file={file}
      templateData={templateData}
      setTemplateData={setTemplateData}
      allGroups={allGroups}
      allRoles={allRoles}
    />
  );
};

export default AccessTemplateViewer;
